export default __webpack_public_path__ + "static/http_certificate-b83be0ebad171b1704f74d9c1c18ce38.png";